const reducer = (obj, arr) => {
  const eslintCompatibleObject = { ...obj };
  const [eslintCompatibleElement0, eslintCompatibleElement1] = arr;
  eslintCompatibleObject[eslintCompatibleElement0] = eslintCompatibleElement1;
  return eslintCompatibleObject;
};

function parseIterator<X>(data: Iterable<X>) {
  return [...data].reduce(reducer, {});
}

export default parseIterator;
